// A gallery of ready-made textures (all procedural, so freely usable).

import { NAMED_PALETTES, NIGHT_PALETTE, WOOD_PALETTE, type TextureSpec } from '../types';

export interface TexturePreset {
  id: string;
  spec: TextureSpec;
}

const P = NAMED_PALETTES;

export const TEXTURE_PRESETS: TexturePreset[] = [
  { id: 'classic', spec: { kind: 'random_dots', style: 'bw', palette: [...P.mono], density: 0.5, dot_size: 1 } },
  { id: 'colorDots', spec: { kind: 'random_dots', style: 'color', palette: [], density: 0.5, dot_size: 2 } },
  { id: 'neonDots', spec: { kind: 'random_dots', style: 'palette', palette: [...P.neon], density: 0.6, dot_size: 2 } },
  { id: 'plasma', spec: { kind: 'plasma', scale: 24, bands: 1.2 } },
  { id: 'psychedelic', spec: { kind: 'plasma', scale: 10, bands: 2.5 } },
  { id: 'stainedGlass', spec: { kind: 'mosaic', scale: 14, edge: 1.5, palette: [...P.candy] } },
  { id: 'cobblestone', spec: { kind: 'mosaic', scale: 10, edge: 2, palette: [...P.earth] } },
  { id: 'bubbles', spec: { kind: 'bubbles', radius: 6, palette: [...P.ocean] } },
  { id: 'pebbles', spec: { kind: 'bubbles', radius: 4, palette: [...P.pastel] } },
  { id: 'confetti', spec: { kind: 'confetti', size: 7, density: 0.6, palette: [...P.candy] } },
  { id: 'autumn', spec: { kind: 'confetti', size: 9, density: 0.8, palette: [...P.fire] } },
  { id: 'wood', spec: { kind: 'rings', scale: 26, rings: 12, palette: [...WOOD_PALETTE] } },
  { id: 'agate', spec: { kind: 'rings', scale: 18, rings: 20, palette: [...P.ice] } },
  { id: 'stars', spec: { kind: 'stars', density: 0.3, palette: [...NIGHT_PALETTE] } },
  { id: 'lava', spec: { kind: 'marble', scale: 20, turbulence: 2.5, palette: [...P.fire] } },
  {
    id: 'marble',
    spec: { kind: 'marble', scale: 24, turbulence: 2, palette: ['#2b2b2b', '#e8e4dc', '#ffffff', '#b8b0a4'] },
  },
  { id: 'ocean', spec: { kind: 'noise', scale: 18, octaves: 5, palette: [...P.ocean] } },
  { id: 'jungle', spec: { kind: 'camo', scale: 14, palette: [...P.forest] } },
  { id: 'gold', spec: { kind: 'worley', scale: 12, palette: [...P.gold] } },
  { id: 'rainbowStripes', spec: { kind: 'stripes', stripe_width: 5, waviness: 0.8, palette: [...P.rainbow] } },
];
